import React from 'react';

function ConsultarPlaca() {
  return <h1>Consulta de Placa</h1>;
}

export default ConsultarPlaca;
